import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'
import SeaTracker from '@/integrations/tracking/custom-sea-tracking/SeaTracker'

export const usePageLoadTracking = (objectName: string, pathPattern: string, eventName: string) => {
  const router = useRouter()
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    // Make sure the router is ready
    if (!router.isReady) return

    // Initialize tracker with router to capture full URL including query parameters
    SeaTracker.init(router)

    // Track on initial page load if not tracked yet
    if (router.pathname.includes(pathPattern) && !hasTrackedRef.current) {
      if (eventName === 'View_Tour') {
        SeaTracker.trackViewTour(objectName)
      } else {
        // Add other eventNames as needed
        console.log(`Tracking event ${eventName} not implemented yet`)
      }
      hasTrackedRef.current = true
    }

    // For navigation between different entities
    const handleRouteChange = (url: string) => {
      if (url.includes(pathPattern) && url !== router.asPath) {
        // Reset the flag when navigating to a different entity
        hasTrackedRef.current = false
      }
    }

    router.events.on('routeChangeStart', handleRouteChange)
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router.isReady, router.events, router.asPath, router.pathname, objectName, pathPattern, eventName, router])
}
